module.exports = __webpack_public_path__ + "img/hr-grass-4.23fcc9fd.png";